import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
const { getPublicPageSeo, isNoindexPath } = require('../../site/publicPageSeo');
const { socialImageForPath } = require('../../site/ogTitleCard');

// Search metadata is stable across the name-only experiment and shares the static document source.
export default function CourseSeo({ path }: { path: string }) {
  const { pathname } = useLocation();
  const seo = getPublicPageSeo(path);
  const image = socialImageForPath(path);
  const noindex =
    window.location.hostname.toLowerCase() === 'dev.botspot.trade' || isNoindexPath(pathname);
  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="robots" content={noindex ? 'noindex, follow' : 'index, follow'} />
      <link rel="canonical" href={seo.canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={seo.canonical} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={image.url} />
      <meta property="og:image:width" content={String(image.width)} />
      <meta property="og:image:height" content={String(image.height)} />
      <meta property="og:image:type" content={image.type} />
      <meta property="og:image:alt" content={image.alt} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={image.url} />
      <meta name="twitter:image:alt" content={image.alt} />
    </Helmet>
  );
}
